(function() {
  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  }   

  const collection_tab = document.querySelectorAll('[data-tab-tragger]') || null;
    
  // data-teb-content
  if(collection_tab){
    collection_tab.forEach(tab => {
          tab.addEventListener("click", (event) => {
            
           event.preventDefault();
            //  const collection_tab_main = document.querySelector('[data-collection-tab-tragger]') || null;
            // const collection_tab_content = document.querySelectorAll('[data-collection-tab-tragger]') || null;
            const collection_tab_main = event.target.closest('[data-tab-main-custom]') || null;
              if(!collection_tab_main) return;
            const collection_tab_content = collection_tab_main.querySelectorAll('[data-teb-content]') || null;
            const collection_tab_content_tab = collection_tab_main.querySelectorAll('[data-tab-tragger]') || null;
             if(!collection_tab_content) return;
               collection_tab_content_tab.forEach(tab_hide => {
                     tab_hide.classList.remove('active');
                });
            collection_tab_content.forEach(tab_hide_content => {
                     tab_hide_content.setAttribute("hidden",true);
                });
              event.target.classList.add('active');
              const tab_coltent = document.querySelector(event.target.hash) || null;
                  if(tab_coltent){
                      tab_coltent.removeAttribute("hidden");
                  }
              });
        });
}
  
  
})();  


document.addEventListener("DOMContentLoaded", function () {
  var togglePWDicon = document.querySelectorAll(".togglePassword");
  togglePWDicon.forEach(function(togglePWDicons){
   if(togglePWDicon){
    togglePWDicons.addEventListener("click", function (e) {
      e.preventDefault();
      const input = togglePWDicons.closest('.passowrd-eye-show');
      const inpuFinal = input.querySelector('.password_input');
      
      const button = this;
  
      if (inpuFinal.type === "password") {
          inpuFinal.type = "text";
          button.classList.add("disabled"); // Enable the button
      } else {
          inpuFinal.type = "password";
          button.classList.remove("disabled"); // Disable the button
      }
    });
    }
  });
  var customResetButton = document.querySelector(".drawer__footer .reset-button button");
  if(customResetButton){
    customResetButton.addEventListener('click',function(){
      var originalReset = document.querySelector(".facets__active-filters .js-clear-all");
      var drawerCloseBtn = document.querySelector(".drawer__footer .js-close-drawer-mob");
      if(originalReset){
        originalReset.click();
        drawerCloseBtn.click();
      }
    });
  }

  const activeFilters = document.querySelector('details-disclosure.facets__active-filters');
  var resetElem = document.querySelector(".drawer__footer .reset-button");
      // Check if the element does NOT have the `hidden` attribute
  if(activeFilters){
    if (!activeFilters.hasAttribute('hidden')) {
      // Logic to execute when `hidden` attribute is NOT present
      console.log('The element is visible. Add your logic here.');
      resetElem.classList.remove('hidden');
    } else {
      // Logic to execute when `hidden` attribute IS present
      console.log('The element is hidden. Add your alternate logic here.');
      resetElem.classList.add('hidden');
    }
  }

  var faqTitles = document.querySelectorAll(".main-faq-button .faq-button,.faq-button .btn");
  if(faqTitles.length > 0){
    faqTitles.forEach(function(faqTitle){
      faqTitle.addEventListener('click',function(){
        faqTitles.forEach(function(faqTitle){
            faqTitle.classList.remove('active');
        });
        faqTitle.classList.add('active');
        var currentTitle = faqTitle.getAttribute("data-title");
        

        var faqBlocks = document.querySelectorAll(".accordion-wrapper .accordion-block-wrap");
        if(faqBlocks.length > 0){
          faqBlocks.forEach(function(faqBlock){
            faqBlock.classList.remove('hidden');
            var faqBlockTitle = faqBlock.getAttribute("data-faq-block");
            
            if(faqBlockTitle != currentTitle){
              faqBlock.classList.add('hidden');
            }else{
             var ContentTab = faqBlock.querySelector('details');
              var tab = faqBlock.querySelector('summary') || null;
              console.log("tab", faqBlock);
              console.log(!ContentTab.hasAttribute('open'))
              if (tab) {
                  // Ensure the details element is open
                  if (!ContentTab.hasAttribute('open')) {
                      tab.click();  
                  }
              
              }
            }
          });
        }
      });
    });
  }

  // var searchCloseIcons = document.querySelectorAll(".close-icon-search");
  // if(searchCloseIcons.length){
  //   searchCloseIcons.forEach(function(searchIcon){
  //     searchIcon.addEventListener('click',function(){
  //       console.log("click...");
  //       document.body.classList.remove(".search-popup-open");
  //     });
  //   });
  // }


// ------ register page email error check
  
// const btnClick = document.querySelector('.register_submit_btn button');

// function validateEmail(email) {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return emailRegex.test(email);
// }

// if (btnClick) {
//   btnClick.addEventListener('click', function (event) {
//     const email = document.getElementById("register-email").value;
//     const errorSpan = document.getElementById("email_error");

//     // If the email is not valid, show the error and return false to stop the event
//     if (!validateEmail(email)) {
//       errorSpan.style.display = "inline";  // Show error message
//       event.preventDefault();  // Prevent the form submission
//       return false;  // Stop further event propagation
//     } else {
//       errorSpan.style.display = "none";  // Hide the error message if valid
//     }
//   });
// }


const btnClick = document.querySelector('.register_submit_btn button');

// Function to validate email
function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

if (btnClick) {
  btnClick.addEventListener('click', function (event) {
    // Select all input fields and their corresponding error messages
    const inputs = document.querySelectorAll(".form__field input");
    let isValid = true;
    let isErrorDisplayed = false; // Flag to ensure only one error is shown

    // Loop through each input field
    inputs.forEach(input => {
      if (!isErrorDisplayed) {  // Check if we have already displayed an error
        // Get the value of the current input
        const value = input.value;
        const errorSpan = input.closest('.form__field').querySelector('.email_error');
        
        // Hide the error message initially
        errorSpan.style.display = "none";

        // Validation checks for each field
        if (input.type === "email" && !validateEmail(value)) {
          errorSpan.textContent = "Invalid email address";
          errorSpan.style.display = "inline";
          isValid = false;
          isErrorDisplayed = true; // Stop further error displays
        } else if (input.required && !value) {
          // Check if the field is required and empty
          errorSpan.textContent = `${input.placeholder} is required`;
          errorSpan.style.display = "inline";
          isValid = false;
          isErrorDisplayed = true; // Stop further error displays
        }
      }
    });

    // Prevent form submission if any field is invalid
    if (!isValid) {
      event.preventDefault();
    }
  });
}

});

  

const backclick = document.querySelector('.back-btn button');
if (backclick) {
  
backclick.addEventListener('click', function (event) {
    window.history.back();
});
}